import { CUSTOMER_CREATE } from '@constants';
import { CustomerForm, toCustomerPayload } from '@forms/CustomerForm';
import { CustomerFormValues } from '@forms/CustomerForm/types';
import { useAuthHttp } from '@hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';

export function AddCustomer() {
  useDocumentTitle('FLOX - Add Customer');
  const authHttp = useAuthHttp();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const pages = [
    { name: 'Home', href: '/', current: false },
    { name: 'Customer Master', href: '/customer-master', current: false },
    {
      name: 'Add New Customer',
      href: '/customer-master/create',
      current: true,
    },
  ];

  const handleOnSubmit = async (data: CustomerFormValues) => {
    setIsSubmitting(true);
    try {
      const { data: createCustomerData } = await authHttp.post(
        CUSTOMER_CREATE,
        {
          customer: toCustomerPayload(data),
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (createCustomerData) {
        navigate('/customer-master');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CustomerForm
      onSubmit={handleOnSubmit}
      isSubmitting={isSubmitting}
      header='New Customer'
      pages={pages}
    />
  );
}
